import { Component } from '@angular/core';
import {
    ModalClass,
    NotificationIdentifier,
    NotificationIdentifierModel,
    NotificationModel,
    NotificationService,
    StatusModel,
} from '@evorait/pace-core';
import {
    FormsState,
    getFormNotification,
    initialNotificationIdentifier,
    NotificationUtilities,
} from '@evorait/pace-forms';
import { faFlag } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { EquipmentConfigurationComponent } from '../../../details/equipment-configuration/equipment-configuration.component';
import EquipmentConfigurationModel from '../../../details/equipment-configuration/equipment-configuration.model';
import { EquipmentHistoryComponent } from '../../../details/equipment-history/equipment-history.component';
import EquipmentHistoryModel from '../../../details/equipment-history/equipment-history.model';

@Component({
    selector: 'pace-forms2-wrapper',
    templateUrl: './forms2-wrapper.component.html',
    styleUrls: ['./forms2-wrapper.component.scss'],
})
export class Forms2WrapperComponent {
    public modalInstance: BsModalRef;
    public readonly faFlag = faFlag;

    public notification$: Observable<{
        id: NotificationIdentifier;
        model: NotificationModel;
        status: StatusModel;
    }>;
    public constructor(
        private readonly modalService: BsModalService,
        private readonly store: Store<FormsState>,
        private readonly notificationService: NotificationService,
    ) {
        this.notification$ = this.store.select(getFormNotification).pipe(
            filter((notification) => !NotificationUtilities.compare(notification, initialNotificationIdentifier)),
            map((notification) => {
                const notificationModel = this.notificationService.getNotificationByIdentifier(
                    new NotificationIdentifierModel(notification.frontId, notification.qmNum, notification.maNum),
                );

                if (typeof notificationModel === 'undefined') {
                    throw new Error(
                        `Forms2WrapperComponent: constructor: unable to load notification for identifier '${NotificationUtilities.toString(
                            notification,
                        )}'`,
                    );
                }
                return {
                    id: notification,
                    model: notificationModel,
                    status: this.notificationService.getStatus(notificationModel),
                };
            }),
        );
    }

    public openEquipmentHistory(notification: NotificationModel): void {
        if (typeof notification === 'undefined') {
            throw new Error(`Forms2WrapperComponent: openEquipmentHistory: Notification is undefined!`);
        }
        this.modalInstance = this.modalService.show(EquipmentHistoryComponent, {
            backdrop: 'static',
            class: ModalClass.MODAL_LARGE,
            initialState: {
                model: new EquipmentHistoryModel(notification),
            },
            ariaLabelledBy: 'equipment-history-modal-title',
        });
    }

    public openEquipmentConfig(notification: NotificationModel): void {
        if (typeof notification === 'undefined') {
            throw new Error(`Forms2WrapperComponent: openEquipmentConfig: Notification is undefined!`);
        }
        this.modalInstance = this.modalService.show(EquipmentConfigurationComponent, {
            backdrop: 'static',
            class: ModalClass.MODAL_LARGE,
            initialState: {
                model: new EquipmentConfigurationModel(notification),
                notification,
            },
            ariaLabelledBy: 'equipment-configuration-modal-title',
        });
    }
}
